document.addEventListener('DOMContentLoaded', function () {

  // ── Recently Viewed injection ──
  function injectBtn(card, imgSelector) {
    if (card.querySelector('.wlh-orvp-btn')) return;
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;

    var productUrl = link.getAttribute('href');
    var name = (card.querySelector('h4.product_title') || {}).innerText || '';
    var img = card.querySelector('img');
    var image = img ? img.src : '';
    var priceEl = card.querySelector('.orvp-price');
    var price = priceEl ? priceEl.innerText.replace(/[^0-9.]/g, '') : '0';

    var btn = document.createElement('div');
    btn.classList.add('wlh-orvp-btn', 'wishlist-hero-custom-button', 'wishlisthero-floating');
    btn.setAttribute('data-wlh-id', productUrl);
    btn.setAttribute('data-wlh-link', productUrl);
    btn.setAttribute('data-wlh-price', price);
    btn.setAttribute('data-wlh-name', name.trim());
    btn.setAttribute('data-wlh-image', image);
    btn.setAttribute('data-wlh-mode', 'icon_only');
    btn.style.cssText = 'position:absolute;top:8px;right:8px;z-index:10;';

    var wrap = card.querySelector(imgSelector);
    if (wrap) {
      wrap.style.position = 'relative';
      wrap.appendChild(btn);
      document.dispatchEvent(new CustomEvent('wishlist-hero-add-to-custom-element', { detail: btn }));
    }
  }

  function injectRVP() {
    document.querySelectorAll('.orvp-card-container').forEach(function(c) {
      injectBtn(c, 'a:first-child');
    });
  }

  // ── Force WLH to render icons on Related Products ──
  function reinitWLH() {
    if (window.WishlistHero) {
      ['init', 'refresh', 'render', 'update', 'mount'].forEach(function(fn) {
        if (typeof window.WishlistHero[fn] === 'function') {
          try { window.WishlistHero[fn](); } catch(e) {}
        }
      });
    }
    ['wishlist-hero:reinit', 'wlh:reinit', 'wishlist-hero:refresh',
     'wishlist-hero-add-to-custom-element'].forEach(function(ev) {
      document.dispatchEvent(new CustomEvent(ev));
    });
    document.querySelectorAll('.sb-card__image-wrap .wishlisthero-floating').forEach(function(btn) {
      document.dispatchEvent(new CustomEvent('wishlist-hero-add-to-custom-element', { detail: btn }));
    });
  }

  injectRVP();

  var rec = document.querySelector('product-recommendations');
  if (rec) {
    new MutationObserver(function() {
      if (rec.classList.contains('product-recommendations--loaded')) {
        [500, 1000, 1500, 2500].forEach(function(delay) {
          setTimeout(reinitWLH, delay);
        });
      }
    }).observe(rec, { attributes: true, childList: true, subtree: true });
  }

  var rvp = document.querySelector('.orvp-carousel-container, .orvp-track');
  if (rvp) {
    new MutationObserver(function(m) {
      if (m.some(function(x) { return x.addedNodes.length > 0; })) {
        setTimeout(injectRVP, 400);
      }
    }).observe(rvp, { childList: true, subtree: true });
  }

  var i = 0;
  var t = setInterval(function() {
    injectRVP();
    reinitWLH();
    if (++i >= 20) clearInterval(t);
  }, 600);

});

document.addEventListener('click', function(e) {
  var link = e.target.closest('.orvp-card-container a[href="javascript:void(0)"]');
  if (link) {
    e.preventDefault();
    var card = link.closest('.orvp-card-container');
    if (card) {
      var detailLink = card.querySelector('a[href*="/products/"]');
      if (detailLink) {
        window.location.href = detailLink.href;
      }
    }
  }
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.list-payment svg title').forEach(function(el) {
    el.remove();
  });
});